import type { Client } from '@urql/core'
import { graphql } from 'app/generated/gql'
import type { AIAgentConfigurationJson as AIAgentConfigurationType } from 'app/types/entities'
import { EntityStore } from './EntityStore'

type AIAgentConfigurationListResult = { hits: AIAgentConfigurationType[]; total: number; page: number }

// aiAgentConfigurations returns [AIAgentConfiguration!]! directly (no pagination wrapper)
const LIST_QUERY = graphql(`
  query AIAgentConfigurations($search: String, $locationId: ID) {
    aiAgentConfigurations(search: $search, locationId: $locationId) {
      version
      createdDate
      updatedDate
      id
      orgId
      workspaceId
      locationId
      agentName
      agentVoiceId
      greeting
      businessName
      businessAddress
      services {
        name
        lowPrice
        highPrice
        consultRequired
        consultPrice
      }
      servicesNotOffered {
        name
        lowPrice
        highPrice
        consultRequired
        consultPrice
      }
      offers {
        name
        patientStatus
        eligibleInsurance
        onlyEmergencyEligible
      }
      emergencyApptId
      generalApptId
      smsConfirmationEnabled
      postBookingMessage
      hygienePostBookingMessage
      consultApptId
      limitedExamApptId
      voiceAgentAddendum
      cleaningRequiresInitialExam
      pediatricOnly
      voiceAgentTools
    }
  }
`)

export class AIAgentConfigurationStore extends EntityStore<AIAgentConfigurationType, AIAgentConfigurationListResult> {
  constructor(client: Client) {
    super(client, {
      listQuery: LIST_QUERY,
      getQuery: undefined,
      extractList: (data: any) => ({
        hits: data.aiAgentConfigurations,
        total: data.aiAgentConfigurations.length,
        page: 0,
      }),
      extractOne: (data: any) => data.aiAgentConfigurations?.[0],
      extractMutated: (data: any) => data.opsUpdateAIAgentLocationConfig,
    })
  }
}
